import * as React from 'react'

import { SVGResponsive } from '../common'

interface IProps {
  size: 'big' | 'small'
}

function ProgramClosed(props: IProps) {
  const { size } = props

  switch (size) {
    case 'big':
      return renderBig()
    case 'small':
      return renderSmall()
  }
}

function renderBig() {
  return (
    <SVGResponsive height={88} width={94}>
      <g clip-path="url(#a)">
        <rect
          y="36.895"
          width="85.911"
          height="51.547"
          rx="8"
          transform="rotate(-7.51 0 36.895)"
          fill="#CBCBCB"
        />
        <path
          d="M20.353 38.662 47.622 4.607 69.134 31.85l-48.781 6.81Z"
          stroke="#9A9A9A"
          stroke-width="2"
        />
        <rect
          x="1"
          y="35.836"
          width="85.911"
          height="51.547"
          rx="8"
          transform="rotate(-7.51 1 35.836)"
          fill="#fff"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M55.804 44.553a2.75 2.75 0 0 1 .508 3.856L42.11 66.924a2.75 2.75 0 0 1-4.364-3.348l14.202-18.515a2.75 2.75 0 0 1 3.856-.508Z"
          fill="#9A9A9A"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M35.59 47.218a2.75 2.75 0 0 1 3.856-.509L57.96 60.911a2.75 2.75 0 1 1-3.348 4.364L36.098 51.073a2.75 2.75 0 0 1-.508-3.855Z"
          fill="#9A9A9A"
        />
        <rect
          x="4.251"
          y="37.81"
          width="80.624"
          height="46.26"
          rx="8"
          transform="rotate(-7.51 4.25 37.81)"
          stroke="#F1F1F1"
          stroke-width="2"
        />
        <circle cx="47.277" cy="3.965" r="3.965" fill="#FFC6BE" />
        <path
          d="M23.513 25.414a2.33 2.33 0 0 0-.927-.927l-.44-.24a.282.282 0 0 1 0-.494l.44-.24c.392-.215.713-.535.927-.927l.24-.44a.28.28 0 0 1 .493 0l.24.44c.215.392.535.713.927.927l.44.24a.282.282 0 0 1 0 .494l-.44.24a2.325 2.325 0 0 0-.926.927l-.24.44a.28.28 0 0 1-.493 0l-.241-.44ZM16.27 30.12a3.495 3.495 0 0 0-1.391-1.39l-.66-.36a.423.423 0 0 1 0-.74l.66-.36a3.493 3.493 0 0 0 1.39-1.39l.361-.66a.42.42 0 0 1 .74 0l.36.66a3.496 3.496 0 0 0 1.39 1.39l.66.36a.422.422 0 0 1 0 .74l-.66.36a3.489 3.489 0 0 0-1.39 1.39l-.36.66a.42.42 0 0 1-.74 0l-.36-.66ZM73.513 85.414a2.33 2.33 0 0 0-.927-.927l-.44-.24a.282.282 0 0 1 0-.494l.44-.24c.392-.215.713-.535.927-.927l.24-.44a.28.28 0 0 1 .493 0l.24.44c.215.392.535.713.927.927l.44.24a.282.282 0 0 1 0 .494l-.44.24a2.325 2.325 0 0 0-.926.927l-.24.44a.28.28 0 0 1-.493 0l-.241-.44ZM81.27 87.12a3.495 3.495 0 0 0-1.391-1.39l-.66-.36a.423.423 0 0 1 0-.74l.66-.36a3.493 3.493 0 0 0 1.39-1.39l.361-.66a.42.42 0 0 1 .74 0l.36.66a3.496 3.496 0 0 0 1.39 1.39l.66.36a.422.422 0 0 1 0 .74l-.66.36a3.489 3.489 0 0 0-1.39 1.39l-.36.66a.42.42 0 0 1-.74 0l-.36-.66Z"
          fill="#E6E6E6"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h94v88H0z" />
        </clipPath>
      </defs>
    </SVGResponsive>
  )
}

function renderSmall() {
  return (
    <SVGResponsive height={48} width={50}>
      <path
        d="M.57 24.451a4.364 4.364 0 0 1 3.756-4.896l37.806-4.984a4.364 4.364 0 0 1 4.897 3.756l2.534 19.223a4.364 4.364 0 0 1-3.756 4.896L8.001 47.43a4.364 4.364 0 0 1-4.897-3.756L.57 24.451Z"
        fill="#CBCBCB"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M25.979 1.637 9.819 21.818l28.908-4.036L25.98 1.637Zm-.006 1.752L12.385 20.36l24.307-3.394L25.972 3.39Z"
        fill="#9A9A9A"
      />
      <path
        d="M1.116 23.873a4.364 4.364 0 0 1 3.756-4.896l37.806-4.984a4.364 4.364 0 0 1 4.896 3.755l2.535 19.223a4.364 4.364 0 0 1-3.756 4.897L8.546 46.852a4.364 4.364 0 0 1-4.896-3.756L1.116 23.873Z"
        fill="#fff"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M30.439 24.302a1.5 1.5 0 0 1 .277 2.103l-7.747 10.099a1.5 1.5 0 0 1-2.38-1.826l7.747-10.1a1.5 1.5 0 0 1 2.103-.276Z"
        fill="#9A9A9A"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.413 25.755a1.5 1.5 0 0 1 2.103-.277l10.099 7.746a1.5 1.5 0 0 1-1.826 2.38l-10.1-7.746a1.5 1.5 0 0 1-.276-2.103Z"
        fill="#9A9A9A"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.348 25.021a4.909 4.909 0 0 1 4.226-5.508l34.947-4.607a4.909 4.909 0 0 1 5.508 4.225l2.157 16.364a4.909 4.909 0 0 1-4.225 5.508L10.014 45.61a4.91 4.91 0 0 1-5.509-4.225L2.348 25.021Zm4.368-4.427A3.818 3.818 0 0 0 3.43 24.88l2.157 16.363A3.818 3.818 0 0 0 9.87 44.53l34.948-4.607a3.818 3.818 0 0 0 3.286-4.285l-2.157-16.364a3.818 3.818 0 0 0-4.285-3.286L6.716 20.594Z"
        fill="#F1F1F1"
      />
      <path d="M27.95 2.163a2.163 2.163 0 1 1-4.325 0 2.163 2.163 0 0 1 4.325 0Z" fill="#FFC6BE" />
      <path
        d="M12.825 13.862a1.27 1.27 0 0 0-.505-.505l-.24-.131a.154.154 0 0 1 0-.27l.24-.13a1.27 1.27 0 0 0 .505-.506l.132-.24a.153.153 0 0 1 .268 0l.131.24c.117.214.292.388.506.505l.24.131a.153.153 0 0 1 0 .27l-.24.13a1.267 1.267 0 0 0-.506.506l-.13.24a.153.153 0 0 1-.27 0l-.13-.24ZM8.874 16.43a1.906 1.906 0 0 0-.758-.759l-.36-.196a.23.23 0 0 1 0-.404l.36-.197c.32-.175.583-.437.758-.758l.197-.36a.23.23 0 0 1 .403 0l.197.36c.176.321.438.583.758.759l.36.196a.23.23 0 0 1 0 .404l-.36.197c-.32.175-.583.437-.758.758l-.197.36a.229.229 0 0 1-.403 0l-.197-.36ZM40.098 46.589a1.271 1.271 0 0 0-.506-.506l-.24-.131a.154.154 0 0 1 0-.27l.24-.13a1.27 1.27 0 0 0 .506-.506l.131-.24a.153.153 0 0 1 .269 0l.131.24c.117.214.292.389.506.506l.24.13a.154.154 0 0 1 0 .27l-.24.131a1.268 1.268 0 0 0-.506.506l-.131.24a.152.152 0 0 1-.269 0l-.131-.24ZM44.329 47.52a1.906 1.906 0 0 0-.759-.759l-.36-.196a.23.23 0 0 1 0-.404l.36-.197c.32-.175.583-.437.759-.758l.197-.36a.23.23 0 0 1 .402 0l.197.36c.176.32.438.583.759.759l.36.196a.23.23 0 0 1 0 .404l-.36.197c-.321.175-.583.437-.759.758l-.197.36a.229.229 0 0 1-.402 0l-.197-.36Z"
        fill="#E6E6E6"
      />
    </SVGResponsive>
  )
}

export default React.memo(ProgramClosed)
